import { checkModalOnlySubscription, checkModalSubscription } from '../../helper';

/**
 * Проверяет, если удален провайдер у Subscription услуги
 * Присылается Mode = 0 (Manual)
 */
export const checkIsDeleteServiceSubscriptionProvider = (modal) => {
  const isSubscription = checkModalSubscription(modal);
  const isEdit = !!modal?.id;
  const isModeManual = Number(modal?.mode) === 0;

  return isSubscription && isEdit && isModeManual;
}

export const getModeOptions = (modal) => {
  const isSubscriptionAndSubscriptionReselling = checkModalSubscription(modal);
  const isSubscription = checkModalOnlySubscription(modal);
  const isEdit = !!modal?.id;
  const isModeManual = Number(modal?.mode) === 0;

  const modes = [
    {
      name: 'Auto',
      value: 1,
    },
    {
      name: 'Manual',
      value: 0,
    },
  ];
  return modes.filter((mode) => {
    const { value } = mode;
    switch (value) {
    case 0:
      /*
        Правка https://www.notion.so/perfectpanel/subscription-914a6b153a164992a01dfb97f2e982b3
        Если клиент удалил провайдера, у него Mode выставляется Manual
        Даем возможность заново выбрать Mode = Auto и сменить провайдера
       */
      if (isSubscriptionAndSubscriptionReselling && isEdit && isModeManual) {
        return true;
      }
      if (isSubscription) {
        return true;
      }
      return !isSubscriptionAndSubscriptionReselling;
    default:
      return true;
    }
  })
};

export const checkIsDisabledMode = (options, modal) => {
  const isSubscription = checkModalOnlySubscription(modal);
  const isEdit = !!modal?.id;

  /*
    Задача: https://www.notion.so/perfectpanel/Subscriptions-PR-42-373c46983d37459285899e74621ebee1
    Разрешаем менять Mode = Manual только при создании Subscription
   */
  if (isSubscription && isEdit) {
    return true;
  }

  return options.length === 1
}
